import React from 'react';
export function TimelineSection() {
  const timelineItems = [{
    day: 'Day 1',
    title: 'The Initial Clearing',
    desc: 'You perform the Salt & Sound Protocol. Most women report feeling an unexpected sense of calm within the first session.'
  }, {
    day: 'Day 2',
    title: 'The Digital Detox',
    desc: "You identify and mute the sources of 'digital envy' that have been feeding the interference loop without you realizing it."
  }, {
    day: 'Day 3',
    title: 'The Mirror Reversal',
    desc: 'You redirect the energy that was being absorbed from others back to its source — neutralized, not with anger, but with intention.'
  }, {
    day: 'Day 4',
    title: 'The Home Reset',
    desc: "You clear the physical spaces where stagnant energy collects and 'bad events' seem to repeat."
  }, {
    day: 'Day 5',
    title: 'The Relationship Audit',
    desc: 'You identify the specific relationship dynamic that has been the largest source of your frequency drain.'
  }, {
    day: 'Day 6',
    title: 'The Abundance Unlocking',
    desc: 'With the interference largely cleared, you use the 417hz track and a specific scripting exercise to begin calling in what you want — for the first time on a clean signal.'
  }, {
    day: 'Day 7',
    title: 'The Seal',
    desc: 'You complete the protective frequency layer to prevent future interference from entering your field.'
  }];
  return <section className="w-full py-24 px-4 bg-navy-dark bg-grain" data-id="element-332">
      <div className="max-w-4xl mx-auto flex flex-col items-center" data-id="element-333">
        <p className="text-gold text-sm tracking-[0.2em] uppercase mb-6 font-medium text-center" data-id="element-334">
          THE 7-DAY REVERSAL TIMELINE
        </p>

        <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-cream text-center mb-16" data-id="element-335">
          What Women Experience When The Interference Clears
        </h2>

        <div className="relative w-full" data-id="element-336">
          {/* Vertical Line Desktop */}
          <div className="hidden md:block absolute left-[120px] top-0 bottom-0 w-px bg-gold/30" data-id="element-337"></div>

          <div className="flex flex-col space-y-12" data-id="element-338">
            {timelineItems.map((item, index) => <div key={index} className="relative flex flex-col md:flex-row items-center md:items-start group" data-id="element-339">
                {/* Day Label */}
                <div className="md:w-[120px] flex-shrink-0 flex md:justify-start justify-center mb-4 md:mb-0 z-10" data-id="element-340">
                  <div className="bg-navy border border-gold text-gold font-bold px-4 py-2 rounded-full text-sm tracking-widest uppercase shadow-[0_0_15px_rgba(201,168,76,0.1)] group-hover:bg-gold group-hover:text-navy transition-colors duration-300" data-id="element-341">
                    {item.day}
                  </div>
                </div>

                {/* Content */}
                <div className="md:pl-12 text-center md:text-left flex-1" data-id="element-342">
                  <h3 className="font-serif text-2xl text-cream mb-3" data-id="element-343">
                    {item.title}
                  </h3>
                  <p className="text-cream/70 leading-relaxed text-lg" data-id="element-344">
                    {item.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}